import determineBondMaturityDate from "./determine_bond_maturity_date";

export const determineBondInfo = (bondInfo, startGameDate) => {
    const maturityDateObj = determineBondMaturityDate(bondInfo, startGameDate);
    let couponText = "None";
    if (bondInfo.coupon === true){
        const couponFrequency = bondInfo.couponFrequencyText;
        couponText = "Paid " + couponFrequency;
    }
    const couponRate = (+bondInfo.couponRate * 100).toFixed(1) + "%"
    const returnObj = {...maturityDateObj, couponText: couponText, couponRate: couponRate}
    return returnObj;
}
export default determineBondInfo;